<script setup>
import { computed, useSlots } from 'vue'

const props = defineProps({
    compact: {
        type: Boolean,
        default: false,
    },
})

const slots = useSlots()

const hasHeaderSlot = computed(() => !!slots.header || !!slots.title)

const paddingClass = computed(() => {
    return props.compact ? 'p-3' : slots.header || slots.title || slots.topRight ? 'px-4 pb-4' : 'p-4'
})

const headerContainerClass = computed(() => {
    let classes = [];

    classes.push(props.compact ? '-mx-3 px-3' : '-mx-4 px-4')

    classes.push('mb-3 border-b border-gray-100 flex justify-between pb-2 pt-2 bg-gray-50')

    return classes.join(' ')
})

</script>

<template>
    <div
        class="rounded-xl border border-gray-200 bg-white"
        :class="[paddingClass]"
    >
        <div
            v-if="hasHeaderSlot"
            :class="headerContainerClass"
            class="card-basic-header rounded-t-xl"
        >
            <span class="text-sm">
                <slot name="header" />
                <slot name="title" />
            </span>
            <span class="-mr-2">
                <slot name="topRight"></slot>
            </span>
        </div>

        <div>
            <slot name="body" />
            <slot />
        </div>
    </div>
</template>

<style scoped>
.card-basic-header :deep(h3), .card-basic-header :deep(p) {
    margin-bottom: 0;
}
</style>
